/* APEX MEN - עגלה v13: כמו v12 + תיקון הבאג שהחליף כמויות בין המוצר למתנות במעבר לצ'קאאוט */
(function () {
  'use strict';

  /* ---------- הגדרות ---------- */
  var MAIN_VARIANT = 44541307453506;
  var MAIN_HANDLE = 'apex-men';
  var WAS_PER_UNIT = 360;            /* מחיר לפני הנחה ליחידה, לחישוב שורת ההנחה */
  var GIFTS = [44542786043970, 44542784372802, 44542783979586, 44542783029314];
  var GIFT_HANDLES = ['סיכוי-לזכות-בשעון-חכם', 'אפליקציית-אימונים-apex', 'קופסת-נסיעות-apex', 'המדריך-לעלייה-בטסטוסטרון'];
  var SECTION_KEY = 'cart-drawer-section';

  var CSS = [
    '.ax-cart-banner{direction:rtl;background:#FBEFE7;padding:13px 16px;margin:0 0 8px;font-family:Heebo,Assistant,system-ui,sans-serif;border-radius:10px}',
    '.ax-cart-banner__t{display:flex;align-items:center;justify-content:space-between;gap:10px;font-weight:700;font-size:14px;color:#111}',
    '.ax-cart-banner__pill{flex:0 0 auto;background:#111;color:#fff;border-radius:99px;padding:6px 14px;font-size:11px;font-weight:800;letter-spacing:.6px;white-space:nowrap}',
    '.ax-cart-banner__bar{margin-top:10px;height:10px;border-radius:99px;background:#e7d9d0;overflow:hidden}',
    '.ax-cart-banner__bar i{display:block;height:100%;width:100%;border-radius:99px;background:#111}',
    '.ax-free-under{direction:rtl;display:block;margin-top:3px;font-family:Heebo,Assistant,system-ui,sans-serif;font-size:13px;font-weight:800;color:#FF5600}',
    '.ax-gift-row .cart-items__price,.ax-gift-row [class*="unit-price"]{display:none!important}',
    '.ax-cart-badges{direction:rtl;display:flex;justify-content:center;gap:22px;margin:10px 0 4px;font-family:Heebo,Assistant,system-ui,sans-serif;font-weight:700;font-size:12px;color:#111}',
    '.ax-cart-badges span{display:inline-flex;align-items:center;gap:6px}',
    '.ax-cart-badges svg{width:17px;height:17px;flex:0 0 auto;stroke:#FF5600;fill:none;stroke-width:1.8}',
    /* סיכום הזמנה בסגנון הרפרנס: שלוש שורות נקיות מעל הכפתור */
    '.ax-cart-summary{direction:rtl;font-family:Heebo,Assistant,system-ui,sans-serif;margin:4px 0 12px;padding:2px 0 0}',
    '.ax-cart-summary__row{display:flex;align-items:baseline;justify-content:space-between;gap:12px;padding:4px 0;font-size:14px;font-weight:600;color:#111}',
    '.ax-cart-summary__row--discount b{color:#E4340C}',
    '.ax-cart-summary__row--total{border-top:1px solid #E5E5E5;margin-top:6px;padding-top:10px;font-size:16px;font-weight:800}',
    '.ax-cart-summary__row b{font-weight:inherit;white-space:nowrap}',
    /* מסתיר את שורת המיסים/סכום משוער של התבנית */
    '.ax-hide-row{display:none!important}',
    /* כפתור תשלום: כתום, בולט, עם טקסט ההנחה */
    '.cart__checkout-button{background:linear-gradient(180deg,#FF6B1A 0%,#FF5600 100%)!important;border-color:#FF5600!important;color:#fff!important;font-weight:800!important;box-shadow:0 6px 20px rgba(255,86,0,.34)!important}'
  ].join('\n');

  var busy = false;
  var mainQty = 1;
  var lastCartTotal = -1;            /* באגורות, מתעדכן מכל קריאת cart.js */
  var backoffUntil = 0;
  var lastItemsLen = -1;
  var healCooldown = 0;
  var origFetch = window.fetch.bind(window);

  /* =======================================================================
     תיקון קריטי (v13): הטופס של העגלה שולח ל-/cart מערך updates[] לפי
     סדר השורות במסך, ושופיפיי מתאים אותו לשורות העגלה לפי מיקום בלבד.
     אנחנו מזיזים את שורת התוסף למעלה (עיצוב), ולכן בלחיצה על "לתשלום"
     הכמות של התוסף נחתה על השורה הראשונה בעגלה - המתנה - והתוסף חזר ל-1.
     ככה נוצר המצב של "שעון חכם x3 + תוסף x1 ב-180 ש"ח" בצ'קאאוט.
     הפתרון: לפני כל שליחה של טופס העגלה מנטרלים את שדות ה-updates[],
     כך שהטופס עובר לצ'קאאוט בלי לגעת בכמויות. העגלה כבר נכונה.
     ======================================================================= */
  function disarmCartQuantities() {
    var forms = document.querySelectorAll('form#cart-form, form[action="/cart"], form[action$="/cart"]');
    Array.prototype.forEach.call(forms, function (f) {
      var inputs = f.querySelectorAll('[name="updates[]"], [name^="updates["]');
      Array.prototype.forEach.call(inputs, function (i) { i.disabled = true; });
    });
  }
  /* גם על הקליק וגם על ה-submit - הקליק רץ ראשון ונותן שכבת ביטחון נוספת */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#checkout, .cart__checkout-button, [name="checkout"]') : null;
    if (b) disarmCartQuantities();
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var act = f.getAttribute('action') || '';
    if (f.id === 'cart-form' || /\/cart$/.test(act)) disarmCartQuantities();
  }, true);

  /* ---------- קריאות רשת עמידות ---------- */
  function getCart() {
    return origFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        try { return JSON.parse(t); }
        catch (e) { backoffUntil = Date.now() + 30000; return null; }
      });
  }

  /* ---------- רענון חכם של המגירה ---------- */
  function rebuildSection() {
    return origFetch('/?sections=' + SECTION_KEY, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j[SECTION_KEY];
        var sec = document.getElementById('shopify-section-' + SECTION_KEY);
        if (!html || !sec) return false;
        var tpl = document.createElement('template');
        tpl.innerHTML = html;
        sec.replaceChildren(tpl.content);
        schedule();
        return true;
      }).catch(function () { return false; });
  }
  function drawerRowCount() {
    var d = document.getElementById('cart-drawer');
    return d ? d.querySelectorAll('tbody tr.cart-items__table-row').length : 0;
  }
  function refreshDrawer() {
    return getCart().then(function (cart) {
      if (!cart) return false;
      lastItemsLen = cart.items.length;
      lastCartTotal = cart.total_price;
      /* התצוגה חייבת להראות בדיוק את מה שבעגלה - אחרת בונים מחדש */
      if (drawerRowCount() !== cart.items.length) return rebuildSection();
      var cic = document.querySelector('cart-items-component');
      if (cic && typeof cic.fetchCartData === 'function') {
        try {
          return Promise.resolve(cic.fetchCartData()).catch(function () {})
            .then(function () { schedule(); return true; });
        } catch (e) {}
      }
      return rebuildSection();
    });
  }

  /* ---------- פתיחה וסגירה - תמיד על האלמנט הנוכחי, עם רשת ביטחון ---------- */
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
    setTimeout(function () {
      var dlg = document.querySelector('#cart-drawer dialog');
      if (dlg && !dlg.open && dlg.showModal) { try { dlg.showModal(); } catch (e) {} }
    }, 350);
  }
  function forceCloseDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.close === 'function') { try { d.close(); } catch (e) {} }
    setTimeout(function () {
      var dlg = document.querySelector('#cart-drawer dialog');
      if (dlg && dlg.open) { try { dlg.close(); } catch (e) {} }
    }, 350);
  }
  /* ה-X של Horizon עלול להפנות לעותק ישן אחרי בנייה מחדש - מאזין שתמיד עובד */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.theme-drawer__close-button, [on\\:click="#cart-drawer/close"]') : null;
    if (!t) return;
    var sec = document.getElementById('shopify-section-' + SECTION_KEY);
    if (!sec || !sec.contains(t)) return;
    forceCloseDrawer();
  }, true);
  /* גם אייקון העגלה בהדר מקבל רשת ביטחון לפתיחה */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('cart-icon, .header-actions__cart-icon, button[aria-controls*="cart" i]') : null;
    if (!t) return;
    setTimeout(function () {
      var dlg = document.querySelector('#cart-drawer dialog');
      if (dlg && !dlg.open) openDrawer();
    }, 350);
  }, true);

  /* ---------- מתנות אוטומטיות ---------- */
  function ensureGifts(fromUserAdd) {
    if (busy || Date.now() < backoffUntil) return Promise.resolve(false);
    busy = true;
    return getCart().then(function (cart) {
      if (!cart || !cart.items) { busy = false; return false; }
      var mainLines = cart.items.filter(function (it) {
        return it.variant_id === MAIN_VARIANT || it.handle === MAIN_HANDLE;
      });
      mainQty = mainLines.reduce(function (n, it) { return n + it.quantity; }, 0) || 1;
      lastItemsLen = cart.items.length;
      lastCartTotal = cart.total_price;
      var hasMain = mainLines.length > 0;
      var giftsInCart = cart.items.filter(function (it) { return GIFTS.indexOf(it.variant_id) !== -1; });

      /* אין תוסף בעגלה: מוציאים את כל המתנות */
      if (!hasMain && giftsInCart.length > 0) {
        var clear = {};
        giftsInCart.forEach(function (it) { clear[it.variant_id] = 0; });
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: clear })
        }).then(function () { return true; });
      }
      if (!hasMain) return false;

      /* יש תוסף: משלימים מתנות חסרות (גם אם רק חלק מהן חסרות) */
      var inCartIds = giftsInCart.map(function (it) { return it.variant_id; });
      var missing = GIFTS.filter(function (id) { return inCartIds.indexOf(id) === -1; });
      if (missing.length) {
        return origFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: missing.map(function (id) { return { id: id, quantity: 1 }; }) })
        }).then(function () { return true; });
      }

      /* רשת ביטחון: מתנה היא תמיד יחידה אחת. אם משהו שינה כמות - מחזירים ל-1.
         העדכון לפי מזהה וריאנט ולא לפי מיקום שורה, ולכן לא יכול לפגוע בשורה אחרת. */
      var wrong = giftsInCart.filter(function (it) { return it.quantity !== 1; });
      if (wrong.length) {
        var fix = {};
        wrong.forEach(function (it) { fix[it.variant_id] = 1; });
        return origFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: fix })
        }).then(function () { return true; });
      }
      return false;
    }).then(function (changed) {
      busy = false;
      if (changed || fromUserAdd) {
        refreshDrawer().then(function () {
          if (fromUserAdd) setTimeout(openDrawer, 150);
        });
      }
      schedule();
      return changed;
    }).catch(function () { busy = false; return false; });
  }

  /* לתפוס כל הוספה לעגלה: fetch + XHR + טפסים */
  window.fetch = function () {
    var url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || '');
    var p = origFetch.apply(window, arguments);
    if (/\/cart\/add/.test(url)) {
      p.then(function () { setTimeout(function () { ensureGifts(true); }, 60); });
    } else if (/\/cart\/(change|update)/.test(url)) {
      p.then(function () { setTimeout(function () { ensureGifts(false); }, 60); });
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._axUrl = String(url || '');
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/add/.test(this._axUrl || '')) {
      this.addEventListener('load', function () { setTimeout(function () { ensureGifts(true); }, 60); });
    } else if (/\/cart\/(change|update)/.test(this._axUrl || '')) {
      this.addEventListener('load', function () { setTimeout(function () { ensureGifts(false); }, 60); });
    }
    return origSend.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '')) {
      setTimeout(function () { ensureGifts(true); }, 700);
    }
  }, true);

  /* ---------- קישוט - בתוך המגירה בלבד ---------- */
  function rowHref(row) {
    var link = row.querySelector('a[href*="/products/"]');
    return link ? decodeURIComponent(link.getAttribute('href') || '') : '';
  }
  function isGiftRow(row) {
    var href = rowHref(row);
    return GIFT_HANDLES.some(function (h) { return href.indexOf(h) !== -1; });
  }
  function isMainRow(row) { return rowHref(row).indexOf(MAIN_HANDLE) !== -1; }

  function shekel(n) {
    return '₪' + Math.round(n).toLocaleString('he-IL');
  }

  function decorate() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    /* ריפוי עצמי: אם התצוגה לא תואמת לעגלה האמיתית - בנייה מחדש */
    if (lastItemsLen >= 0 && Date.now() > healCooldown) {
      var shown = drawer.querySelectorAll('tbody tr.cart-items__table-row').length;
      if (shown !== lastItemsLen) {
        healCooldown = Date.now() + 4000;
        rebuildSection();
        return;
      }
    }

    if (!document.head.querySelector('style[data-ax-cart]')) {
      var st = document.createElement('style');
      st.setAttribute('data-ax-cart', '1');
      st.textContent = CSS;
      document.head.appendChild(st);
    }

    var rows = Array.prototype.slice.call(drawer.querySelectorAll('tr.cart-items__table-row'));
    if (!rows.length) return;

    var mainRow = rows.find(isMainRow) || null;

    /* 1) התוסף תמיד ראשון.
          שינוי הסדר הזה הוא ויזואלי בלבד, והוא בטוח רק בזכות disarmCartQuantities()
          שמנטרל את updates[] לפני המעבר לצ'קאאוט. אין לגעת באחד בלי השני. */
    if (mainRow && mainRow.parentElement && mainRow.parentElement.firstElementChild !== mainRow) {
      mainRow.parentElement.insertBefore(mainRow, mainRow.parentElement.firstElementChild);
    }

    /* 2) באנר מעל אזור המוצרים */
    var itemsArea = drawer.querySelector('.cart-drawer__items');
    if (itemsArea && !drawer.querySelector('.ax-cart-banner')) {
      var banner = document.createElement('div');
      banner.className = 'ax-cart-banner';
      banner.innerHTML =
        '<div class="ax-cart-banner__t"><span>פתחת משלוח חינם + מתנות! 🎁</span>' +
        '<span class="ax-cart-banner__pill">משלוח חינם</span></div>' +
        '<div class="ax-cart-banner__bar"><i></i></div>';
      itemsArea.parentElement.insertBefore(banner, itemsArea);
    }

    /* 3) בלי שורת מנוי - אין מנויים באתר. מנקה שאריות מגרסאות קודמות */
    var oldSub = drawer.querySelector('.ax-cart-subline');
    if (oldSub) oldSub.remove();

    /* 4) מתנות: "חינם" אחד מתחת לשם, בלי מחיר בצד */
    rows.filter(isGiftRow).forEach(function (row) {
      row.classList.add('ax-gift-row');
      if (!row.querySelector('.ax-free-under')) {
        var title = row.querySelector('.cart-items__title') || row.querySelector('a[href*="/products/"]');
        if (title) {
          var free = document.createElement('span');
          free.className = 'ax-free-under';
          free.textContent = 'חינם';
          title.insertAdjacentElement('afterend', free);
        }
      }
    });

    /* 5) מסתיר את "מיסים ומכס מחושבים בקופה" ואת שורת הסכום של התבנית */
    var footerEls = drawer.querySelectorAll('.cart-drawer__summary *, .cart-drawer__footer *, [class*="summary" i] *, [class*="footer" i] *');
    Array.prototype.forEach.call(footerEls, function (el) {
      if (el.children.length) return;
      var txt = (el.textContent || '').trim();
      if (!txt) return;
      if (/מיסים|מכס|Taxes|duties/i.test(txt) || /סכום משוער|Estimated total|Subtotal/i.test(txt)) {
        var row = el.closest('div, li, p, dt, dd, dl, tr') || el;
        if (!row.querySelector('.ax-cart-summary') && !row.classList.contains('ax-cart-summary')) {
          row.classList.add('ax-hide-row');
        }
      }
    });

    /* 6) סיכום הזמנה משלנו מעל כפתור התשלום: סכום ביניים / הנחה / סה"כ */
    var checkoutBtn = drawer.querySelector('.cart__checkout-button');
    if (checkoutBtn && lastCartTotal >= 0) {
      var subtotal = WAS_PER_UNIT * Math.max(1, mainQty);
      var total = lastCartTotal / 100;
      var discount = Math.max(0, subtotal - total);
      var html =
        '<div class="ax-cart-summary__row"><span>סכום ביניים</span><b>' + shekel(subtotal) + '</b></div>' +
        '<div class="ax-cart-summary__row ax-cart-summary__row--discount"><span>הנחה (50%)</span><b>-' + shekel(discount) + '</b></div>' +
        '<div class="ax-cart-summary__row ax-cart-summary__row--total"><span>סה"כ לתשלום</span><b>' + shekel(total) + '</b></div>';
      var sum = drawer.querySelector('.ax-cart-summary');
      if (!sum) {
        sum = document.createElement('div');
        sum.className = 'ax-cart-summary';
        checkoutBtn.insertAdjacentElement('beforebegin', sum);
      }
      if (sum.innerHTML !== html) sum.innerHTML = html;
    }

    /* 7) כפתור תשלום: טקסט ההנחה */
    if (checkoutBtn) {
      var want = 'לתשלום ולקבלת 50% הנחה';
      if ((checkoutBtn.textContent || '').trim() !== want) checkoutBtn.textContent = want;
    }

    /* 8) תגיות אמון מתחת לכפתור התשלום */
    if (checkoutBtn && checkoutBtn.parentElement && !drawer.querySelector('.ax-cart-badges')) {
      var badges = document.createElement('div');
      badges.className = 'ax-cart-badges';
      badges.innerHTML =
        '<span><svg viewBox="0 0 24 24"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 18a1.6 1.6 0 1 0 0-.01M18 18a1.6 1.6 0 1 0 0-.01"/></svg>משלוח מהיר וחינם</span>' +
        '<span><svg viewBox="0 0 24 24"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/></svg>אחריות 90 יום להחזר כספי</span>';
      checkoutBtn.insertAdjacentElement('afterend', badges);
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; try { decorate(); } catch (e) {} }, 200);
  }

  var drawerHost = document.getElementById('shopify-section-cart-drawer-section');
  new MutationObserver(schedule).observe(drawerHost || document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { ensureGifts(false); schedule(); });
  setInterval(function () { if (!document.hidden) ensureGifts(false); }, 10000);
  ensureGifts(false); schedule();
})();
